import "./MetricsGrid.css";
import { Card } from "../../../ui";
export default function MetricsGrid({ metrics = [] }) {
  if (!metrics.length) return null;
  return (
    <div className="lud-metrics">
      {metrics.map((m, i) => (
        <Card key={`${m.label}-${i}`} hoverable={false} className="lud-metric">
          <small>{m.label}</small>
          <strong>{m.value}</strong>
          <span>{m.note}</span>
        </Card>
      ))}
    </div>
  );
}
